import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { RecoilRoot } from 'recoil';

import 'allotment/dist/style.css';
import 'react18-json-view/src/style.css';
import '../styles/fonts/karla.css';
import '../styles/fonts/inter.css';
import '../styles/fonts/jetbrains-mono.css';
import '../styles/fonts/open-sans.scss';
import '../styles/tailwind.css';
import '../styles/tokens.css';

import App from '@/app/App';
import { i18n, i18nReady } from '@/app/i18n/i18n';
import { initializeApplicationRuntime } from '@/app/runtime/initializeApplicationRuntime';

async function bootstrap(): Promise<void> {
	await initializeApplicationRuntime();
	await i18nReady;

	const root = document.getElementById('root');
	if (!root) throw new Error("Application root '#root' is missing from index.html");

	createRoot(root).render(
		<I18nextProvider i18n={i18n}>
			<RecoilRoot>
				<App />
			</RecoilRoot>
		</I18nextProvider>
	);
}

bootstrap().catch((error: unknown) => {
	setTimeout(() => {
		throw error;
	});
});
